import {Injectable} from '@angular/core';
import {ApiService} from '../../api.service';
import {Observable} from 'rxjs';
import {AvailablePersistentAddresses, CreatePersistentAddressPayload, PersistentAddress} from './persistent-address.model';


@Injectable({
  providedIn: 'root'
})
export class PersistentAddressesService {

  constructor(
    private readonly apiService: ApiService
  ) {
  }

  public getPersistentAddresses(region: string): Observable<AvailablePersistentAddresses> {
    return this.apiService.get(`/account/persistent-addresses/${region}`);
  }

  public create(data: CreatePersistentAddressPayload): Observable<PersistentAddress> {
    return this.apiService.post('/account/persistent-addresses', data);
  }
}
